import { styled } from '@olxeu-jobs/ui';

export const Button = styled<'button', { $isDragging: boolean }>(
  'button',
  ({ $theme, $isDragging }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: $theme.colors['background-global-secondary'],
    outlineStyle: 'dashed',
    outlineWidth: '1px',
    outlineColor: $theme.colors['icon-brand-alternative'],
    borderRadius: $theme.radii[4],
    paddingLeft: $theme.space[32],
    paddingRight: $theme.space[32],
    paddingTop: $theme.space[24],
    paddingBottom: $theme.space[16],
    gap: $theme.space[16],
    border: 0,
    ':hover': {
      cursor: 'pointer',
    },
    ':disabled:hover': {
      cursor: 'not-allowed',
    },
    ...($isDragging && {
      outlineWidth: '2px',
      backgroundColor: $theme.palettes.gray.gray2,
    }),
  }),
);

export const ContentWrapper = styled('span', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.space[2],
  pointerEvents: 'none',
}));

export const IconWrapper = styled('span', ({ $theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  aspectRatio: 1,
  width: '40px',
  borderRadius: $theme.radii[4],
  backgroundColor: $theme.colors['background-global-primary'],
  padding: $theme.space[8],
  boxShadow: $theme.shadow[4],
  color: $theme.colors['icon-brand-alternative'],
  pointerEvents: 'none',
}));

export const Input = styled('input', () => ({
  display: 'none',
}));

export const LoaderWrapper = styled('div', ({ $theme }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: $theme.colors['background-global-secondary'],
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1,
  borderRadius: $theme.radii[4],
}));
